import $ from 'jquery';
import View from 'mixins/view';
import CommentRatingActionsView from '@ui/comments/comment-rating-actions-view';
import CommentUserActionsView from '@ui/comments/comment-user-actions-view';
import CommentUserInfoView from '@ui/comments/comment-user-info-view';
import CommentContentTextView from '@ui/comments/comment-content-text-view';
import { CommentSocioView } from '@ui/comments/comment-socio-view';
import EditHistoryView from '@ui/comments/edit-history-view';
import CommentReplyView from '@ui/comments/comment-reply-view';
import AvatarView from '@ui/comments/avatar-view';
import EditCommentView from '@ui/comments/edit-comment-view';
import reportCommentsAsync from 'repositories/reportCommentsAsync';
import CommentsService from '@ui/comments/CommentService';
import { siteModel } from 'models/SiteModel';
import Moment from 'moment';
import { find, concat } from 'lodash';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export const elements = {
    commentContainerSelector: 'div.c-comments__content',
    userCommentContainerSelector: '.user-comment__text',
    existingComment: 'article.user-comment',
    recent: '.user-comment--recent',
    blocked: '.user-comment--blocked',
    deleted: '.user-comment--deleted',
    own: '.user-comment--own',
    noReply: '.user-comment--no-reply',
    banInfo: '.user-comment__ban-info',
    navbar: '.js-DockedHeader-Box',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.recentRemoveDelay = 15000;
        this.expandLimit = 5;

        document.addEventListener('FocusComment', (event) => {
          if (parseInt(event.detail.parentCommentId) === model.get('id')) {
            this.expand();
            this.repliesView.showAllReplies();
          }
          if (parseInt(event.detail.id) === model.get('id')) {
            $(document).ready(() => {
              setTimeout(this.focus.bind(this), 1000);
            });
          }
        });
    }
    showFirstComments() {
      if (this.model.get('replies').length > this.expandLimit) {
        this.rootEl.addClass('user-comment--firstCommentsVisible');
      } else {
        this.expand();
      }
    }
    buildRepliesView() {
        this.repliesView = new CommentReplyView(this.getModel());
        this.addChild(this.repliesView);
        // const filter = CommentsService
        //       .getVisibleCommentsCollection()
        //       .get('filter');

        if (this.getModel().get('replies').length) {
            // if (filter === 'date') {
            this.showFirstComments();
            // }
        } else {
          this.rootEl.addClass(elements.noReply.substr(1));
        }
        this.repliesView.render();
        this.rootEl
            .append(this.repliesView.getRootEl());
    }
    focus() {
        this.rootEl.addClass('user-comment--recent');
        const offset = $(`article[data-id="${this.model.get('id')}"]`)
          .offset().top
          - ($(window).height() / 2)
          + (this.rootEl.height() / 2);
        $(window).scrollTop(offset);
    }
    setReplyMode(model) {
        if (this.model.get('parentCommentId') === null) {
            this.expand();
            this.repliesView.setReplyMode(model);
        } else {
            this.parentNode.setReplyMode(model);
        }
    }
    expand() {
        this.rootEl.addClass("expanded");
    }
    collapse() {
        this.rootEl.removeClass("expanded");
    }
    getActiveFilter() {
        return this.parentNode.getActiveFilter();
    }
    setEditMode() {
        // TODO: Update add-comment-view model here
        // What if user try to edit comment, abort it and try agin?
        this.getRootEl().toggleClass("editing");
    }
    buildAvatarView() {
        this.avatarView = new AvatarView(this.getModel().get('User'));
        this.avatarView.render();
        this.addChild(this.avatarView);
    }
    buildErrorContainerView() {
      const id = this.model.get('id');
      const root = !this.model.get('parentCommentId') ? true : this.model.get('parentCommentId');
      this.containerErrorEl = `<div class="comment-error-wrapper"
                                    data-root="${root}"
                                    data-id="${id}">
                               </div>`;
    }
    buildBanInfo() {
      return $(`<div class="${elements.banInfo.substr(1)} rmpl-flex-container rmpl-flex-aligned">${this.model.get('banInfo').termsParagraph}</div>`);
    }
    getFormatedDate() {
      const date = moment(this.model.get('createdAt'));
      const ranges = {
        first: moment.range(moment()
          .subtract(1, 'hours'),
          moment()),
        second: moment.range(moment()
          .subtract(1, 'days'),
          moment()),
      };

      const localeConfig = {
          sameDay: '[dziś]',
          lastDay: '[wczoraj]',
          nextDay: '[jutro]',
          nextWeek: 'DD.MM.YYYY',
          lastWeek: 'DD.MM.YYYY',
          sameElse: 'DD.MM.YYYY',
      };

      if (ranges.first.contains(date)) {
        return date.fromNow();
      } else {
        return `${ date.clone().calendar(null, localeConfig) }, ${ date.clone().format('LTS')}`;
      }
    }
    buildContainerEl() {
        const model = this.getModel();
        const author = model.get('User');

        const date = this.getFormatedDate();
        const User = siteModel.get('User');

        this.containerEl = $(`
            <div class="c-comments__content">
                <div class="cc-content user-comment__text js-Comment-Action-Call">
                    <div class="uct-comment-header rmpl-flex-container rmpl-flex-aligned rmpl-flex-nowrap">
                        <strong class="user-comment__name">
                            ${author.get('displayName')}
                        </strong>
                        <time class="rmpl-flex-item-auto" datetime="${model.get('createdAt')}">
                            ${date}
                        </time>
                    </div>
                </div>
            </div>
        `);

        /*
         * Visible only for moderators and other users who dont see moderator labels
         */
        if (User.isModerator() || !author.isModerator()) {
          const commentSocioView = new CommentSocioView(model);
          commentSocioView.render();
          this.containerEl.find('.user-comment__name').after(commentSocioView.getRootEl());
        }

        const commentContentTextView = new CommentContentTextView(model);
        commentContentTextView.render();
        this.containerEl.find('.cc-content').append(commentContentTextView.getRootEl());

        const commentUserActionsView = new CommentUserActionsView(model);
        const commentRatingActionsView = new CommentRatingActionsView(model);
        const editHistoryView = new EditHistoryView(model);

        commentUserActionsView.render();
        commentRatingActionsView.render();
        editHistoryView.render();

        this.addChild(commentUserActionsView);
        this.addChild(commentRatingActionsView);
        this.addChild(editHistoryView);

        const widgets = [
            commentUserActionsView.getRootEl(),
            editHistoryView.getRootEl(),
            commentRatingActionsView.getRootEl(),
        ];

        if (User.isInModerationMode()) {
          const commentUserInfoView = new CommentUserInfoView(model);
          commentUserInfoView.render();
          this.addChild(commentUserInfoView);
          widgets.splice(1, 0, commentUserInfoView.getRootEl());
        }

        if (model.get('banInfo') && model.get('banInfo').isActive) {
          const banInfo = this.buildBanInfo();
          widgets.push(banInfo);
        }

        this.containerEl
            .find(elements.userCommentContainerSelector)
            .append(widgets);

        if (model.get('EditHistory').length) {
            const editHistoryTrigger = editHistoryView.getTriggerEl();
            editHistoryTrigger.insertAfter(this.containerEl.find('time')[0]);
        }

    }
    buildEditView() {
        this.editCommentView = new EditCommentView();
        this.addChild(this.editCommentView);
        this.editCommentView.edit(this.getModel());
        this.editCommentView.render();
    }
    render() {
        const model = this.model;
        const rootEl = this.rootEl;
        const isOwnComment = siteModel.get('User').isAuthorOf(model);

        this.rootEl.empty();
        this.buildContainerEl();
        this.buildAvatarView();
        this.buildErrorContainerView();

        this.box = $(`<div class="c-comments__box"></div>`);

        this.box.append([
            this.avatarView.getRootEl(),
            this.containerEl,
          ]);

        rootEl
          .removeClass()
          .addClass('user-comment')
          .append(this.box);

        if (model.get('isNew')) {
          rootEl.addClass(elements.recent.substr(1));
          setTimeout(() => {
              this.getRootEl().removeClass(elements.recent.substr(1));
          }, this.recentRemoveDelay);
        }

        if (isOwnComment) {
            this.rootEl.addClass(elements.own.substr(1));
            this.buildEditView();
            rootEl.append(this.editCommentView.getRootEl());
        }

        rootEl.append(this.containerErrorEl);

        if (model.get('parentCommentId') === null) {
            this.buildRepliesView();
        }
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comment-view.js